import { ABOUT_STATEMENTS } from "@/data/content";
import { Eyebrow, MaskedLines, Reveal } from "./shared";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative overflow-hidden border-y border-softblue bg-white py-28 md:py-40"
    >
      <svg
        aria-hidden="true"
        viewBox="0 0 600 600"
        className="pointer-events-none absolute -left-52 bottom-[-14rem] h-[36rem] w-[36rem]"
      >
        <g fill="none" stroke="rgba(11,94,168,0.08)" strokeWidth="1">
          <circle cx="300" cy="300" r="280" />
          <circle cx="300" cy="300" r="205" />
          <path d="M40 320 C 180 220, 420 220, 560 310" stroke="rgba(22,135,217,0.14)" />
        </g>
      </svg>

      <div className="relative mx-auto max-w-[1600px] px-6 md:px-12">
        <div className="grid gap-16 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-5">
            <Eyebrow>About Oswal</Eyebrow>
            <h2 className="mt-7 font-serif font-medium leading-[1.02] tracking-tight text-navy">
              <MaskedLines
                lines={[
                  <span key="a" style={{ fontSize: "clamp(2.8rem, 5.8vw, 5.6rem)" }} className="block">
                    ABOUT
                  </span>,
                  <span key="b" style={{ fontSize: "clamp(2.8rem, 5.8vw, 5.6rem)" }} className="block">
                    OSWAL<span className="text-brand">.</span>
                  </span>,
                ]}
              />
            </h2>
            <Reveal delay={0.3}>
              <div className="mt-12 flex items-center gap-5" aria-hidden="true">
                <span className="h-px w-24 bg-brand/40" />
                <span className="h-2.5 w-2.5 rounded-full bg-brand" />
                <span className="h-px w-12 bg-brand/20" />
              </div>
            </Reveal>
            <Reveal delay={0.35}>
              <p className="mt-12 max-w-xs font-serif text-2xl font-normal italic leading-snug text-ink/75">
                Care that begins with quality — and earns trust every day.
              </p>
            </Reveal>
          </div>

          <div className="lg:col-span-7 lg:border-l lg:border-brand/12 lg:pl-16">
            {ABOUT_STATEMENTS.map((s, i) => (
              <Reveal key={s.n} delay={i * 0.12} y={26}>
                <div
                  className="grid grid-cols-12 items-baseline gap-4 border-t border-brand/12 py-9 last:border-b md:py-11"
                  data-testid={`about-statement-${s.n}`}
                >
                  <span className="col-span-2 font-serif text-lg italic text-brand md:col-span-1">
                    {s.n}
                  </span>
                  <p className="col-span-10 font-serif text-[26px] font-medium leading-snug text-ink md:col-span-11 md:text-[34px]">
                    {s.text}
                  </p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
